import PageLoadHook from './PageLoadHook';

export default class PageLoadHookRunner {
  private _hooks: PageLoadHook[] = [];

  public get hooks(): PageLoadHook[] {
    return this._hooks;
  }

  public constructor() {
  }

  onPageLoad() {
    this.hooks.forEach((hook) => {
      try {
        console.log(`Loading ${hook.name}`);
        hook.onPageLoad();
      } catch (err) {
        console.error(err);
      }
    });
  }
}
